import type { Contact } from "../types";
import { GraphContactList } from "../graph/GraphContactList";
import { GraphContactShow } from "../graph/GraphContactShow";

export default {
  list: GraphContactList,
  show: GraphContactShow,
  recordRepresentation: (record: Contact) =>
    record?.first_name + " " + record?.last_name,
};
